<!-- 
Shows an icon with a tooltip containing warning information.

Used in the levy collection provider and invoice listings, and in the tabs on the levy collection provider screen.
-->
<template>
  <v-tooltip v-if="show" bottom>
    <v-icon v-if="hasWarnings" slot="activator" color="error" class="pa-0 ml-2 mr-0 my-0">error_outline</v-icon>
    <v-icon v-else slot="activator" color="grey lighten-1" class="pa-0 ml-2 mr-0 my-0">info</v-icon>
    <template v-if="hasWarnings">
      <h4 class="subheading">Warnings</h4>
      <ul>
        <li v-for="warning of warningsToDisplay" :key="warning.type">
          <strong>{{ lookups.levyCollectionProviderWarningTypeDescriptions[warning.type] }}{{ (warning.description ? ":" : ".") }}</strong> {{ warning.description | fullStop }}
        </li>
      </ul>
    </template>
    <template v-if="hasFlags">
      <h4 class="subheading">Flags</h4>
      <ul>
        <li v-for="warning of flagsToDisplay" :key="warning.type">
          <strong>{{ lookups.levyCollectionProviderWarningTypeDescriptions[warning.type] }}{{ (warning.description ? ":" : ".") }}</strong> {{ warning.description | fullStop }}
        </li>
      </ul>
    </template>
  </v-tooltip>
</template>

<script>
import _ from "underscore";
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [lookupMixins, filterMixins],
  props: {
    warnings: {
      type: Array,
      required: true
    },
    filter: {
      type: Array,
      default: null
    }
  },
  computed: {
    show() {
      return this.data.length > 0;
    },
    data() {
      if (this.filter && this.filter.length) {
        return _(this.warnings).filter(w => this.filter.includes(w.type));
      }
      return this.warnings;
    },
    warningsToDisplay() {
      return _(this.data).filter(w => !w.forInformationOnly);
    },
    flagsToDisplay() {
      return _(this.data).filter(w => w.forInformationOnly);
    },
    hasWarnings() {
      return _(this.data).some(w => !w.forInformationOnly);
    },
    hasFlags() {
      return _(this.data).some(w => w.forInformationOnly);
    },
    title() {
      if (this.hasFlags && this.hasWarnings) return "Warnings and flags";
      return this.hasFlags ? "Flags" : "Warnings";
    }
  }
};
</script>
